import Swal from "sweetalert2";
import datos from "../services/datos";
import Getters from "./getters";
import { CognitoUserPool, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import AWS from 'aws-sdk';
import { parametros_proyecto, id_proyecto } from "src/configs/config";
// import { ExitToApp } from "@mui/icons-material";

const userData = new datos('usuarios');

// Función para buscar los parametros del proyecto
function buscarPorIdProyecto(id) {
    return parametros_proyecto?.find(objeto => objeto.id === id);
}
const proyecto_encontrado = buscarPorIdProyecto(id_proyecto);

const aws_id_cliente_aplicacion = proyecto_encontrado?.aws_id_cliente_aplicacion;
const aws_id_grupo_user = proyecto_encontrado?.aws_id_grupo_user;
const aws_iam_accessKeyId = proyecto_encontrado?.aws_iam_accessKeyId;
const aws_iam_secretAccessKey = proyecto_encontrado?.aws_iam_secretAccessKey;
const aws_url_clave_firma = proyecto_encontrado?.aws_url_clave_firma;
let useCognito = JSON.parse(localStorage.getItem("cognitoUse"));
console.log('useCognito en UsersData', useCognito);

export const getUsers = async (auth) => {
    userData.join('usuarios_cuentas', 'id_usuarios', 'id');
    userData.join('cuentas_personas_juridicas', 'id_cuentas', 'usuarios_cuentas.id_cuentas');

    // Filtro por cuentas vinculadas al usuario
    const getter = new Getters()
    const user_id_cuentas = getter.getLocalUserCuentas()
    user_id_cuentas ?
        userData.addCondition('usuarios_cuentas', 'id_cuentas', user_id_cuentas, 'in') :
        userData.addCondition('usuarios', 'id', 0, '>');

    const response = await userData.get();

    let users = ''
    if (response.wsResponse.usuarios) {
        users = typeof response.wsResponse.usuarios.user_id === 'undefined' ?
            response.wsResponse.usuarios :
            [response.wsResponse.usuarios]

    }

    return users;
};

export const getUsers2 = async () => {
    userData.join('usuarios_cuentas', 'id_usuarios', 'id');
    userData.join('cuentas_personas_juridicas', 'id_cuentas', 'usuarios_cuentas.id_cuentas');

    // Filtro por cuentas vinculadas al usuario
    const getter = new Getters()
    const user_id_cuentas = getter.getLocalUserCuentas()
    user_id_cuentas ?
        userData.addCondition('usuarios_cuentas', 'id_cuentas', user_id_cuentas, 'in') :
        userData.addCondition('usuarios', 'id', 0, '>');

    const response = await userData.get();
    /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/
    if (response) {
        return [...response.wsResponse.usuarios]
    }
    return response
};

export const getUsersPaginated = async (limit, offset) => {
    const userData = new datos('usuarios');
    userData.join('usuarios_cuentas', 'id_usuarios', 'id');
    userData.join('cuentas_personas_juridicas', 'id_cuentas', 'usuarios_cuentas.id_cuentas');

    // Filtro por cuentas vinculadas al usuario
    const getter = new Getters()
    const user_id_cuentas = getter.getLocalUserCuentas()
    user_id_cuentas ?
        userData.addCondition('usuarios_cuentas', 'id_cuentas', user_id_cuentas, 'in') :
        userData.addCondition('usuarios', 'id', 0, '>');
    userData.addLimitCondition(limit, offset);
    const response = await userData.get();
    /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

    let result = {};
    if (response.wsResponse.usuarios) {
        result = {
            data: [...response.wsResponse.usuarios],
            total_records: response.wsResponse.total_records,
        };
        return result;
    }

};

export const getCuentaBusqueda = async (nombre_fantasia, id_cuentas = false) => {

    const cuentasData = new datos('cuentas_personas_juridicas');
    id_cuentas ?
        cuentasData.addCondition('cuentas_personas_juridicas', 'id_cuentas', id_cuentas, 'in') :
        cuentasData.addCondition('cuentas_personas_juridicas', 'nombre_fantasia', nombre_fantasia, 'like')

    const response = await cuentasData.get();

    let cuentas_personas_juridicas = ''
    if (response.wsResponse.cuentas_personas_juridicas) {
        cuentas_personas_juridicas = typeof response.wsResponse.cuentas_personas_juridicas.id_cuentas === 'undefined' ?
            response.wsResponse.cuentas_personas_juridicas :
            [response.wsResponse.cuentas_personas_juridicas]
    }

    return cuentas_personas_juridicas;
}

const poolData = {
    // UserPoolId: 'us-east-1_IicsmhSD0',
    // ClientId: '58lb2ugcj8ukmk2hl7q9sh4rbq',
    UserPoolId: aws_id_grupo_user,
    ClientId: aws_id_cliente_aplicacion
};

const adminToken = localStorage["cognitoAccessToken"] ? localStorage["cognitoAccessToken"] : ''


AWS.config.update({
    accessKeyId: aws_iam_accessKeyId,  // Reemplaza con tu Access Key ID
    secretAccessKey: aws_iam_secretAccessKey,  // Reemplaza con tu Secret Access Key
    region: 'us-east-1'
});

const cognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider({
    region: 'us-east-1'
});

const deleteUserCognito = async (username) => {
    try {
        const accessToken = localStorage.getItem("cognitoAccessToken");
        const usuarioLogeado = JSON.parse(localStorage.getItem("clientData"));


        const res = await fetch(usuarioLogeado.url_cognito, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
                "x-admin-key": "SIAM_SYNC_2025_9fA3kLxPq"
            },
            body: JSON.stringify({
                action: "deleteUser",
                ownerCode: usuarioLogeado.owner_code,
                username: username
            })
        });

        const data = await res.json();

        if (!res.ok) {
            throw new Error(data.error || "Error eliminando usuario");
        }

        return { status: "true" };
    } catch (err) {
        console.error("❌ Error deleteUser:", err);
        return { status: "false", message: err.message };
    }
};


// eslint-disable-next-line
const migrateUser = async (user) => {

    try {

        let cognitoUser = '';

        const attributeList = [
            // new CognitoUserAttribute({ Name: 'username', Value: user.username }),
            new CognitoUserAttribute({ Name: 'email', Value: user.email }),
            new CognitoUserAttribute({ Name: 'profile', Value: user.id_perfiles }),
            new CognitoUserAttribute({ Name: 'name', Value: user.apellido + ' ' + user.nombre }),

        ];

        await deleteUserCognito(user.userNameOrigi);


        const userPool = new CognitoUserPool(poolData);

        userPool.signUp(user.username, user.password, attributeList, null, (err, result) => {
            if (err) {
                console.error('Error al registrar usuario en Cognito', err);
                return;
            }
            cognitoUser = result.user;

            console.log('Usuario registrado en Cognito:', cognitoUser);
        });

    } catch (error) {
        console.error('Error al migrar usuario:', error);
    }
};

const updateUserAttributes = async (user) => {

    const attributeList = [
        new CognitoUserAttribute({ Name: 'preferred_username', Value: user.username }),
        new CognitoUserAttribute({ Name: 'email', Value: user.email }),
        new CognitoUserAttribute({ Name: 'profile', Value: user.id_perfiles }),
        new CognitoUserAttribute({ Name: 'name', Value: `${user.apellido} ${user.nombre}` })
    ];

    try {
        const params = {
            UserPoolId: poolData.UserPoolId,
            Username: user.userNameOrigi ? user.userNameOrigi : user.username, // Original username
            UserAttributes: attributeList
        };
        // TODO: SE DEBE COMPROBAR SI FUNCIONA EL PARAMETRO aws_url_clave_firma CONTENIDO EN EL ARCHIVO CONFIG

        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: poolData.UserPoolId,
            Logins: {
                [aws_url_clave_firma]: adminToken
            }
        });

        await cognitoIdentityServiceProvider.adminUpdateUserAttributes(params).promise();
        console.log('Atributos de usuario actualizados correctamente por el administrador');
    } catch (error) {
        console.error('Error al actualizar los atributos del usuario:', error);
    }
};
async function callCognito(user, action) {

    try {
        const encodedToken = localStorage.getItem("cognitoAccessToken");

        if (!encodedToken) {
            throw new Error("Sesión inválida. Vuelva a iniciar sesión.");
        }

        const response = await fetch(user.url_cognito, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${encodedToken}`,
                "x-admin-key": "SIAM_SYNC_2025_9fA3kLxPq"

            },
            body: JSON.stringify({
                action,
                ownerCode: user.owner_code,
                username: user.username,
                email: user.email,
                password: atob(user.password),
                attributes: {
                    name: `${user.apellido} ${user.nombre}`,
                    "custom:profile": user.profile || "user"
                }
            })
        });

        let data;
        try {
            data = await response.json();
        } catch {
            throw new Error("Respuesta inválida del servidor");
        }

        if (!response.ok) {
            throw new Error(data?.error || "Error desconocido en Cognito");
        }

        return data;

    } catch (error) {
        console.error("❌ Error Cognito Admin:", error.message);
        throw error; // El caller lo maneja
    }
}



export const postUser = async (user) => {
    let useCognito = JSON.parse(localStorage.getItem("cognitoUse"));
    console.log('user en postUser', user);
    if (user.id) {
        if (user.id) {
            if (!user.nombre || !user.apellido || !user.username || !user.email) {
                let respuesta = { status: 'false' }
                return respuesta;
            }
        } else {
            if (!user.nombre || !user.apellido || !user.username || !user.password || !user.email) {
                let respuesta = { status: 'false' }
                return respuesta;
            }
        }
    }

    const userData = new datos('usuarios');
    let data = {
        "nombre": user.nombre,
        "apellido": user.apellido,
        "username": user.username,
        "password": user.password,
        "email": user.email,
        "id_perfiles": user.id_perfiles,
        "id_owner": user.id_owner,
    };
    if (user.id) {
        if (user.password !== "" && user.password !== undefined) {
            data = {
                "id": user.id,
                "nombre": user.nombre,
                "apellido": user.apellido,
                "username": user.username,
                "password": user.password,
                "email": user.email,
                "id_perfiles": user.id_perfiles,
                "id_owner": user.id_owner,
            };
        } else {
            data = {
                "id": user.id,
                "nombre": user.nombre,
                "apellido": user.apellido,
                "username": user.username,
                "email": user.email,
                "id_perfiles": user.id_perfiles,
                "id_owner": user.id_owner,
            };
        }

    }
    const response = await userData.insert(data);
    const tmp_user_data = response.wsResponse

    if (response.status === "true" && !user.id) {
        if (user.id_cuentas.length > 0) {
            user.id_cuentas.forEach((id) =>
                postCuentasUsuario(id, tmp_user_data.usuarios)
            );

        }
        // TODO:COMENTADO PARA IMPLEMENTACION DE COGNITO
        console.log('useCognito en postUser', useCognito);
        if (response.status === "true" && useCognito) {
            console.log('Creando usuario en Cognito');
            try {
                const action = user.id ? "updateUser" : "createUser";

                await callCognito(user, action);

                console.log("✅ Usuario sincronizado en Cognito");

            } catch (error) {
                await Swal.fire({
                    icon: "error",
                    title: "Error al sincronizar usuario",
                    text: error.message
                });

                return { status: "false", message: error.message };
            }
        }
    }
    // TODO:COMENTADO PARA IMPLEMENTACION DE COGNITO
    else if (response.status === "true" && user.id && useCognito) {

        if (!user.nombre || !user.apellido || !user.username || !user.email) {
            let respuesta = { status: 'false' }
            return respuesta;
        }

        // Si el usuario es un administrador y desea cambiar la contraseña de otro usuario
        if (user.password && user.password !== '') {

            try {
                const action = user.id ? "updateUser" : "createUser";

                await callCognito(user, action);

                console.log("✅ Usuario sincronizado en Cognito");

            } catch (error) {
                await Swal.fire({
                    icon: "error",
                    title: "Error al sincronizar usuario",
                    text: error.message
                });

                return { status: "false", message: error.message };
            }
        }
        // Migrate the user if the username is being changed
        // if ((user.userNameOrigi !== undefined && user.userNameOrigi !== user.username) || (user.userMailOrig !== user.email)) {
        //     await migrateUser(user);
        // } else {
        //     await updateUserAttributes(user);
        // }


    }

    return response;
};

export const postUserMiPerfil = async (user) => {
    if (user.id) {
        if (!user.nombre || !user.apellido || !user.username) {
            let respuesta = { status: 'false' }
            return respuesta;
        }
    } else {
        if (!user.nombre || !user.apellido || !user.username || !user.password || !user.email) {
            let respuesta = { status: 'false' }
            return respuesta;
        }
    }
    const userData = new datos('usuarios');
    let data = {
        "nombre": user.nombre,
        "apellido": user.apellido,
        "username": user.username,
        "password": user.password,
        "email": user.email,
    };
    if (user.id) {
        if (user.password !== "" && user.password !== undefined) {
            data = {
                "id": user.id,
                "nombre": user.nombre,
                "apellido": user.apellido,
                "username": user.username,
                "password": user.password,
                "email": user.email,
            };
        } else {
            data = {
                "id": user.id,
                "nombre": user.nombre,
                "apellido": user.apellido,
                "username": user.username,
                "email": user.email,
            };
        }

    }
    const response = await userData.insert(data);
    const tmp_user_data = response.wsResponse
    if (response.status === "true" && !user.id) {
        if (user.id_cuentas.length > 0) {
            user.id_cuentas.forEach((id) =>
                postCuentasUsuario(id, tmp_user_data.usuarios)
            );

        }
        // TODO:COMENTADO PARA IMPLEMENTACION DE COGNITO
        if (response.status === "true" && useCognito) {


            if (!user.nombre || !user.apellido || !user.username || !user.password || !user.email) {
                let respuesta = { status: 'false' }
                return respuesta;
            }

            let cognitoUser = '';

            const attributeList = [
                // new CognitoUserAttribute({ Name: 'preferred_username', Value: user.username }),
                new CognitoUserAttribute({ Name: 'email', Value: user.email }),
                new CognitoUserAttribute({ Name: 'profile', Value: user.id_perfiles }),
                new CognitoUserAttribute({ Name: 'name', Value: user.apellido + ' ' + user.nombre }),

            ];

            const userPool = new CognitoUserPool(poolData);

            userPool.signUp(user.username, user.password, attributeList, null, (err, result) => {
                if (err) {
                    console.error('Error al registrar usuario en Cognito', err);
                    return;
                }
                cognitoUser = result.user;

                console.log('Usuario registrado en Cognito:', cognitoUser);
            });

        }
    }
    // TODO:COMENTADO PARA IMPLEMENTACION DE COGNITO
    else if (response.status === "true" && user.id && useCognito) {

        // if (user.id) {
        if (!user.nombre || !user.apellido || !user.username || !user.email) {
            let respuesta = { status: 'false' }
            return respuesta;
        }

        // Si el usuario es un administrador y desea cambiar la contraseña de otro usuario
        if (user.password && user.password !== '') {
            try {
                const params = {
                    UserPoolId: poolData.UserPoolId,
                    Username: user.userNameOrigi,
                    Password: user.password,
                    Permanent: true // La contraseña se establece como permanente
                };
                let res = await cognitoIdentityServiceProvider.adminSetUserPassword(params).promise();
                console.log('Contraseña cambiada correctamente por el administrador', res);
            } catch (error) {
                console.error('Error al cambiar la contraseña por el administrador:', error);
                return { status: 'false', message: error.message };
            }
        }
        // Migrate the user if the username is being changed
        if ((user.userNameOrigi !== undefined && user.userNameOrigi !== user.username) || (user.userMailOrig !== user.email)) {
            await migrateUser(user);
        } else {
            await updateUserAttributes(user);
        }


    }
    return response;
};

export const deleteUser = async (id, params) => {
    let usuario = params.row.username ? params.row.username : "";
    let usuarioLogeado = JSON.parse(localStorage.getItem("user")).username;
    let useCognito = JSON.parse(localStorage.getItem("cognitoUse"));

    let status = false;

    if (usuario === usuarioLogeado) {
        await Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "No se puede eliminar el usuario con el cual se encuentra logueado."
        });
    } else {
        await Swal.fire({
            title: "Esta seguro de que desea eliminar este usuario?",
            text: "Si sigue adelante, no se podran revertir los cambios!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, quiero eliminarlo!",
            cancelButtonText: "No, no estoy seguro!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                const userData = new datos('usuarios');
                let data = {
                    id: id
                }
                await deleteCuentasUsuario(id)
                const response = await userData.delete(data);
                console.log('response useCognito', useCognito);
                if (useCognito) {
                    console.log('Eliminando usuario de Cognito:', usuario);
                    let s = await deleteUserCognito(usuario);
                    console.log(s, 'ss')
                }

                if (response.status === "true") {
                    status = true;
                    await Swal.fire(
                        "Eliminado!",
                        "El usuario ha sido eliminado exitosamente",
                        "success"
                    );
                } else {
                    await Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: response.message
                    });
                }
            }
        });
    }

    return status
};


/////post cuentas

export const postCuentasUsuario = async (id_cuenta, id_usuarios) => {
    const userData = new datos('usuarios_cuentas');
    let data = {
        "id_usuarios": id_usuarios,
        "id_cuentas": id_cuenta,
    }
    const response = await userData.insert(data);

    return response;
};

export const deleteCuentasUsuario = async (id) => {
    let status = false;
    const userData = new datos('usuarios_cuentas');
    let data = { "id_usuarios": id }
    const response = await userData.delete(data);
    if (response.status === 'true') {
        status = response.status
    }

    return status
};

export const getUsersByEmail = async (correo) => {
    localStorage.setItem(`estadoPeticionModelos`, 'true');
    const userData = new datos('usuarios');

    userData.addCondition('usuarios', 'id', 0, '>');
    userData.addCondition('usuarios', 'email', `'${correo}'`, '=');

    const response = await userData.get();
    console.log("response en getUsersByEmail", response);
    let users = ''
    if (response.wsResponse.usuarios) {
        users = typeof response.wsResponse.usuarios.user_id === 'undefined' ?
            response.wsResponse.usuarios :
            [response.wsResponse.usuarios]

    }
    console.log("users en getUsersByEmail", users);
    return users;
};


export const getUsersByUsername= async (username) => {
    localStorage.setItem(`estadoPeticionModelos`, 'true');
    console.log("datis", localStorage.getItem("owner_code"));
    const userData = new datos('usuarios');

    userData.addCondition('usuarios', 'id', 0, '>');
    userData.addCondition('usuarios', 'username', `'${username}'`, '=');

    const response = await userData.get();

    let users = ''
    if (response.wsResponse.usuarios) {
        users = typeof response.wsResponse.usuarios.user_id === 'undefined' ?
            response.wsResponse.usuarios :
            [response.wsResponse.usuarios]

    }
    console.log("users en getUsersByEmail", users);
    return users;
};


export const postUserNewPassword = async (user, newPassword) => {
     localStorage.setItem(`estadoPeticionModelos`, 'true');
    console.log("user en postUserNewPassword", user);


    if (!user || !newPassword) {
        let respuesta = { status: 'false' }
        return respuesta;
    } 


    const userData = new datos('usuarios');
    let data = {
        "nombre": user.nombre,
        "apellido": user.apellido,
        "username": user.username,
        "password":  btoa(newPassword),
        "email": user.email,
        "id_perfiles": user.id_perfiles,
        "id_owner": user.id_owner,
        "id": user.id
    };

    const response = await userData.insert(data);
    const respuesta = {
        ...response.wsResponse,
        status: true,
    }
    return respuesta;
}